import React from "react";
// import mac1 from '.././images/home/home3.jpg';
import mac from '.././images/home/macbook-pro.jpg'
function Section(){
    return(
        <div>
            <section className="main-highlyte-6">
            <div><p className="amharic">VISION ቪዥን Website Development</p></div>
                <div className="internal-wrapper">
                    
        <div className="model3">
            Vision Website
        </div>
        <div className="product-title3">
        Technology Solution
        </div>
        <div className="brief-discriptio">
        For All type of organization and personal Portfolio             
        </div>
        <div className="links">
            <ul>
                <li><a href="https://t.me/@mesfin9090">35% discount</a></li>
                {/* <li><a href="#">E-Commerce</a></li> */}
            </ul>
        </div>
    </div>
</section>
               <section className="main-highlyte-wrapper">
<div className="internal-wrapper">
                <div className="model">
                   {/* Service */}
                </div>
                <div className="product-title">
                   Services
                </div>
                <div className="brief-discriptio">
                Designed and implemented both frontend and backend components of Web applications.
                </div>
                <div className="links">
                    <ul>
                        <li><a href="#">Hosting Websites</a></li>
                        <li><a href="#">housing the files, data, and content that make up a 
                        website on a server with one year warranty that is connected to the Internet.</a></li>
                    </ul>
                </div>
                    {/* <div className="home1"><a href="#"><img src={mac1} alt="" /></a></div> */}
                    <div className="model">
                    <p>With Google map location your organization</p>
      
  </div>
  <div className="product-title">
      {/* MacBook-pro */}
  </div>
  <div className="brief-discriptio">
      {/* The best for the brightest */}
  </div>
  <div className="links">
      <ul>
          {/* <li><a href="#">Learn more</a></li> */}
          {/* <li><a href="#">Buy</a></li> */}
      </ul>
  </div>
                    <div className="home"><a href="#"><img src={mac} alt="" /></a></div>
            </div>
        </section>
        <section className="main-highlyte-2">
            <div className="internal-wrapper">
                <div className="model">
                    {/* E-Commerce */}
                </div>
                <div className="product-title">
                ቪዥን E-commerce
                </div>
                <div className="brief-discriptio">
                   For online Shop
                </div>
                <div className="links">
                    <ul>
                        <li><a href="https://fir-f9914.web.app/">ቪዥን more</a></li>
                        <li><a href="https://fir-f9914.web.app/">Choice Us </a></li>
                    </ul>
                </div>
            </div>
        </section>
        <section className="main-highlyte-3">
            <div className="internal-wrapper">
                <div className="model3">
                  
                </div>
                <div className="product-title3">
                    Just the right way of everything
                </div>
                <div className="brief-discriptio">
                    Come first.
                </div>
                <div className="links">
                    <ul>
                        <li><a href="https://github.com/messfind">more</a></li>
                        <li><a href="https://github.com/messfind">see more</a></li>
                    </ul>
                </div>
                </div>
                <section className="main">
      <div className="watch">
          <div className="model3">
            Standard
          </div>
          <div className="product-title3">
          1.Up to 10 pages
                        </div>
                        <div className="product-title3">
  2.Responsive Web Pages
  </div>
          <div className="brief-discriptio">
          3.Social media Integration
                        </div>
                        <div className="brief-discriptio">
                        4.Free Training
                        </div>
                        <div className="brief-discriptio">
                        5.Free 1 Year Domain and Hosting
</div>
                    </div>

      <div className="phone">
          <div className="model3">
          Professional Plan
          </div>
          <div className="product-title3">
          1.Up to 25 pages
                        </div>
                        <div className="product-title3">
                        2.Responsive Web Pages
</div>
          <div className="brief-discriptio">
          3.Social media Integration
                           </div>
                            <div className="brief-discriptio">
                     4.Add booking with Email
                        </div>
                        <div className="brief-discriptio">
                        5.1 Year Revision & Free Training
                        </div>
                        <div className="brief-discriptio">
                        6.Free 1 Year Domain and Hosting
</div>
      </div>





  </section>
        </section>
        <section className="main">
            <div className="watch">
                <div className="model3">
                    Watch
                </div>
                <div className="product-title3">
                    Just the right way of everything
                </div>
                <div className="brief-discriptio">
                    To advert your location with google map and attract customers!
                </div>
                <div className="links">
                    <ul>
                        <li><a href="">Sell online</a></li>
                        <li><a href="">Save time</a></li>
                    </ul>
                </div>
            </div>
            <div className="phone">
                <div className="model3">
                    Card is here
                </div>
                <div className="product-title3">
                    Just the right amount of everything
                </div>
                <div className="brief-discriptio">
                   you market will be simple
                </div>
                <div className="links">
                    <ul>
                        <li><a href="https://t.me/@mesfin9090">Contact us</a></li>
                        <li><a href="https://t.me/@mesfin9090">fast solution</a></li>
                    </ul>
                </div>
            </div>
        </section>
        
        </div>
    )
}

export default Section;